<template>
  <div class="section-panel text-center">
    <div class="container-fluid">
      <div class="title">
        <h3>{{$t('settings.users')}}</h3>
      </div>
      <div class="text-left">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/panel/settings?active=users' }">Users</el-breadcrumb-item>
            <el-breadcrumb-item>{{modeForm}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="col-md-8 ml-auto mr-auto">
        <div class="card plain">
            <div class="card-body">
            <form id="form-user" role="form" @submit.prevent="onFormSubmit">
                <div class="title">
                  
                </div>
                <el-divider></el-divider>
                <div class="row p-2">
                    <div class="col-md-6">
                        <fg-input
                            label="Nombre"
                            class="has-label input-lg"
                            v-model="formData.name"
                        ></fg-input>
                    </div>
                    <div class="col-md-6">
                        <fg-input
                            label="Correo electrónico"
                            class="has-label input-lg"
                            v-model="formData.email"
                        ></fg-input>
                    </div>
                </div>

                <div class="row p-2">
                    <div class="col-md-6">
                        <fg-input
                            label="Teléfono"
                            class="has-label input-lg"
                            v-model="formData.phone"
                        ></fg-input>
                    </div>
                    <div class="col-md-6 text-center">
                      <span class="demo-input-label">Perfil</span>
                      <el-select clearable filterable placeholder="Select" v-model="formData.role_id" @change="handleRolSelected">
                        <el-option
                          v-for="role in roles"
                          :key="role.id"
                          :label="role.name"
                          :value="role.id">
                        </el-option>
                      </el-select>
                      
                    </div>
                </div>
                <el-divider></el-divider>
                
                <div class="card-footer text-center">
                    <router-link
                        class="btn text-white btn-round btn-default"
                        to="/panel/settings?active=users">
                        {{$t('settings.button_cancel')}}
                    </router-link>
                    &nbsp;
                    <el-button size="medium" type="info" round native-type="submit">
                        {{$t('settings.button_save')}}
                    </el-button>
                </div>
                

            </form>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput } from '@/components';
import { DatePicker,Breadcrumb, BreadcrumbItem, Divider, Input, Button, MessageBox, Message, Select, Option } from 'element-ui';
import _ from 'lodash'

import Settings from '@/providers/Settings'
const provider = new Settings()

export default {
  name: 'user-form',
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Input.name]: Input,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
        loading: false,
        formData: {
          name: null,
          phone: null,
          email: null,
          role_id: null
        },
        roles: [],
        rolSelect: null,
        modeForm: 'New'
    }
  },
  mounted() {
    this.getUser()
    this.getRoles()
  },
  computed: {
    
  },
  methods: {
    onFormSubmit () {
      this.loading = true
      let id = this.$route.params.id
      if (id) {
        console.info(JSON.stringify(this.formData))
        provider.patchUser(id, this.formData).then((response) => {
          this.error = null
          Message({
            type: 'success',
            message: 'Operación exitosa'
          })
          setTimeout(() => {
              this.loading = false
              this.$router.push('/panel/settings?active=users')
          }, 3000);
        }).catch((err) => {
          console.info('error post users request')
          console.info(err)
        })
      } else {
        provider.postUser(this.formData).then((response) => {
          this.error = null
          Message({
            type: 'success',
            message: 'Operación exitosa'
          })
          setTimeout(() => {
              this.loading = false
              this.$router.push('/panel/settings?active=users')
          }, 3000);
        }).catch((err) => {
          Message({
            type: 'warning',
            message: 'No se guardó la información, intente nuevamente'
          })
          console.info('error post users request')
          console.info(err)
        })
      }
    },
    getRoles() {
      provider.getData('roles', 50, 1).then((response) => {
        console.info('get roles response')
        let data = response.data.data
        this.roles = data
      }).catch((err) => {
        console.info('error get roles request')
        console.info(err)
      })
    },
    getUser() {
      if (this.$route.params && this.$route.params.id) {
        this.modeForm = 'Edit'
        let id = this.$route.params.id
        provider.getUser(id).then((response) => {
          console.info('get user response')
          let data = response.data.data
          if(data && data.attributes) {
            this.formData.id = data.id
            this.formData.name = data.attributes.name
            this.formData.email = data.attributes.email
            this.formData.phone = data.attributes.phone
            this.formData.role_id = data.attributes.role_id
          }
        }).catch((err) => {
          console.info('error get user request')
          console.info(err)
        })
      }else {
        this.modeForm = 'New'
      }
    },
    handleRolSelected() {

    }
  },
  watch: {
  }
};
</script>
<style>
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demo-input-label {
    text-align: center !important;
    display: block;
    padding: 5px !important;
  }
</style>